import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import Calendar from "./Calendar";
import { CalendarStatusType, CalendarType, PageEnum } from "src/helpers/Enums";
import List from "./List";
import apiService from "src/services/api.service";
import NewSchedule from "./NewSchedule";
import CalendarDetail from "./CalendarDetail";
import Revenue from "./Revenue";
import Empty from "src/components/Empty";
import DeleteSchedule from "./DeleteSchedule";
import CancelSchedule from "./CancelSchedule";
import SchedulePopup from "./SchedulePopup";
import CreateLink from "./CreateLink";

const AllCalendar = () => {
  const [type, setType] = useState(CalendarType.Calendar);
  const [list, setList] = useState([]);
  const [openNewSchedule, setOpenNewSchedule] = useState(false);
  const [openCalendarDetail, setOpenCalendarDetail] = useState(false);
  const [date, setDate] = useState(new Date());
  const [day, setDay] = useState();
  const [listForDetail, setListForDetail] = useState([]);
  const [pending, setPending] = useState();
  const [isUpdate, setIsUpdate] = useState(true);
  const [enterRevenue, setEnterRevenue] = useState(false);
  const [chosenCalendar, setChosenCalendar] = useState();
  const [chosenCalendarsForDelete, setChosenCalendarsForDelete] = useState();
  const [dateForNewSchedule, setDateForNewSchedule] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const [openCancelSchedule, setOpenCancelSchedule] = useState(false);
  const [chosenCalendarForCancel, setChosenCalendarForCancel] = useState();
  const [openSchedulePopup, setOpenSchedulePopup] = useState(false);
  const [schedulePopupData, setSchedulePopupData] = useState(null);
  const [openCreateLink, setOpenCreateLink] = useState(false);
  const [createLinkData, setCreateLinkData] = useState(null);

  useEffect(() => {
    if (isUpdate) {
      apiService.getAllCalendar(date).then((response) => {
        setList(response.data);
      });
      setIsUpdate(false);
    }
  }, [date, isUpdate]);

  useEffect(() => {
    if (openCalendarDetail) {
      setListForDetail(
        list?.filter(
          (item) =>
            new Date(item.date).toISOString().split("T")[0] ===
            new Date(date?.getFullYear(), date?.getMonth(), day)
              .toISOString()
              .split("T")[0]
        )
      );
    }
  }, [list]);

  const handleType = (calendarType) => {
    setType(calendarType);
  };

  const closeModals = () => {
    setOpenNewSchedule(false);
    setOpenCalendarDetail(false);
    setEnterRevenue(false);
    setOpenDelete(false);
    setOpenCancelSchedule(false);
    setOpenSchedulePopup(false);
    setSchedulePopupData(null);
    setOpenCreateLink(false);
    setCreateLinkData(null);
  };

  const handleOpenCalendarDetail = (chosenDay, list, pendingNum) => {
    setPending(pendingNum);
    setDay(chosenDay);
    setListForDetail(list);
    setOpenCalendarDetail(true);
  };

  const handleRevenue = (item, chosenDay) => {
    if (item?.status === CalendarStatusType.CREATED) {
      apiService
        .updateRevenue({ id: item?._id, status: "SCHEDULED" })
        .then(() => {
          setIsUpdate(true);
          setChosenCalendar(item);
          setOpenSchedulePopup(false);
          setSchedulePopupData(null);
        });
    } else {
      setDay(chosenDay);
      setChosenCalendar(item);
      setOpenCalendarDetail(false);
      setOpenSchedulePopup(false);
      setSchedulePopupData(null);
      setEnterRevenue(true);
    }
  };

  const handleSchedulePopup = (calendar, chosenDay) => {
    setOpenCalendarDetail(false);
    setSchedulePopupData({ calendar, day: chosenDay });
    setOpenSchedulePopup(true);
  };

  const normalizeUrlEntry = (entry) => {
    if (typeof entry === "string") {
      return { directUrl: entry, redirectUrl: entry };
    }
    return {
      directUrl: entry?.directUrl ?? entry?.direct_url ?? "",
      redirectUrl:
        entry?.redirectUrl ?? entry?.redirect_url ?? entry?.url ?? "",
    };
  };

  const handleCopyAndUse = async (
    calendar,
    { directUrl, redirectUrl, previewUrl }
  ) => {
    if (!calendar?._id) return;

    const existingUrls = (calendar.url ?? []).map(normalizeUrlEntry);
    const updatedUrls = [
      ...existingUrls,
      {
        directUrl: directUrl ?? "",
        redirectUrl: redirectUrl ?? "",
      },
    ];

    if (previewUrl) {
      try {
        await navigator.clipboard.writeText(previewUrl);
      } catch {
        // ignore clipboard errors
      }
    }

    await apiService.updateCalendarUrls(calendar._id, updatedUrls);

    const updatedCalendar = { ...calendar, url: updatedUrls };
    setSchedulePopupData((prev) =>
      prev?.calendar?._id === calendar._id
        ? { ...prev, calendar: updatedCalendar }
        : prev
    );
    setCreateLinkData((prev) =>
      prev?.calendar?._id === calendar._id
        ? { ...prev, calendar: updatedCalendar }
        : prev
    );
    setIsUpdate(true);
    setOpenCreateLink(false);
    setCreateLinkData(null);
  };

  const handleAddSchedule = (day) => {
    setDateForNewSchedule(new Date(date?.getFullYear(), date?.getMonth(), day));
    setOpenNewSchedule(true);
  };

  const handleDeleteSchedule = (calendar) => {
    setChosenCalendarsForDelete(calendar);
    setChosenCalendar(calendar);
    setOpenDelete(true);
  };

  const handleCancelSchedule = (calendar) => {
    setChosenCalendarForCancel(calendar);
    setOpenCancelSchedule(true);
  };

  const deleteSchedule = (date) => {
    if (date) {
      apiService.deleteCalendarDate(date).then(() => {
        setIsUpdate(true);
        setOpenDelete(false);
      });
    } else {
      apiService.deleteCalendar(chosenCalendar._id).then(() => {
        setIsUpdate(true);
        setOpenDelete(false);
      });
    }
  };

  const submitCancelSchedule = (payload) => {
    if (!chosenCalendarForCancel?._id || !payload) return;
    apiService
      .cancelCalendar(chosenCalendarForCancel._id, {
        cancel_reason_title: payload.cancel_reason_title ?? "",
        cancel_reason_description: payload.cancel_reason_description ?? "",
      })
      .then(() => {
        setIsUpdate(true);
        setOpenCancelSchedule(false);
      });
  };

  return (
    <div className={"Page"}>
      <Header
        type={type}
        handleType={handleType}
        setOpenNewSchedule={setOpenNewSchedule}
      ></Header>
      <div className={"px-6 w-full"}>
        {list?.length < 1 ? (
          <Empty
            handleNew={() => setOpenNewSchedule(true)}
            title={"No Schedule Found"}
            description={
              "No schedule has been created yet. Use the 'New Schedule' button below to create one right away."
            }
            type={"Schedule"}
            menu={PageEnum.ALLCALENDAR}
            setDate={setDate}
            setIsUpdate={setIsUpdate}
          ></Empty>
        ) : type === CalendarType.Calendar ? (
          <Calendar
            date={date}
            setDate={setDate}
            list={list}
            setIsUpdate={setIsUpdate}
            handleOpenCalendarDetail={handleOpenCalendarDetail}
            handleAddSchedule={handleAddSchedule}
            handleDeleteSchedule={handleDeleteSchedule}
          ></Calendar>
        ) : (
          <List
            list={list}
            date={date}
            handleRevenue={handleRevenue}
            handleSchedulePopup={handleSchedulePopup}
            handleDeleteSchedule={handleDeleteSchedule}
            handleCancelSchedule={handleCancelSchedule}
          ></List>
        )}
      </div>
      {openNewSchedule && (
        <NewSchedule
          close={closeModals}
          setIsUpdate={setIsUpdate}
          startDate={dateForNewSchedule}
        ></NewSchedule>
      )}
      {openCalendarDetail && (
        <CalendarDetail
          close={closeModals}
          day={day}
          date={date}
          handleRevenue={handleRevenue}
          handleSchedulePopup={handleSchedulePopup}
          list={listForDetail}
          pending={pending}
          handleDeleteSchedule={handleDeleteSchedule}
          handleCancelSchedule={handleCancelSchedule}
        ></CalendarDetail>
      )}
      {enterRevenue && (
        <Revenue
          close={closeModals}
          setIsUpdate={setIsUpdate}
          calendar={chosenCalendar}
          date={date}
          day={day}
        ></Revenue>
      )}
      {openDelete && (
        <DeleteSchedule
          setOpenDelete={setOpenDelete}
          calendars={chosenCalendarsForDelete}
          close={closeModals}
          deleteSchedule={deleteSchedule}
        />
      )}
      {openCancelSchedule && (
        <CancelSchedule
          item={chosenCalendarForCancel}
          calendars={chosenCalendarForCancel ? [chosenCalendarForCancel] : []}
          close={closeModals}
          deleteSchedule={submitCancelSchedule}
          submitWithReason={true}
        />
      )}
      {openSchedulePopup && (
        <SchedulePopup
          item={schedulePopupData?.calendar}
          day={schedulePopupData?.day}
          onCreateLink={(calendar, chosenDay) => {
            setCreateLinkData({ calendar, day: chosenDay });
            setOpenCreateLink(true);
          }}
          onSchedule={(calendar, chosenDay) => {
            handleRevenue(calendar, chosenDay);
          }}
          close={() => {
            setOpenSchedulePopup(false);
            setSchedulePopupData(null);
          }}
        />
      )}
      {openCreateLink && (
        <CreateLink
          item={createLinkData?.calendar}
          day={createLinkData?.day}
          onCopyAndUse={(linkData) =>
            handleCopyAndUse(createLinkData?.calendar, linkData)
          }
          close={() => {
            setOpenCreateLink(false);
            setCreateLinkData(null);
          }}
        />
      )}
    </div>
  );
};

export default injectIntl(AllCalendar);
